import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey('de367d386a0d6edb7c1672be30968ebbTz05OTU0MSxFPTE3NTk5Nzg4Mzg0NjksUz1wcm8sTE09YW5udWFsLFBWPVEzLTIwMjQsS1Y9Mg==')
